import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { fCoins } from "src/utils/formatNumber";
import { fDateTime } from "src/utils/formatTime";
import { getTypeName } from "src/utils/transactionUtils";
import CoinIcon from "../icons/CoinIcon";
import UserLevelChip from "../level/UserLevelChip";

export default function CoinTransactionsTable(props) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>User</TableCell>
						{/*<TableCell>User Value</TableCell>*/}
						<TableCell>Amount</TableCell>
						<TableCell>Type</TableCell>
						{/*<TableCell>Pair</TableCell>*/}
						<TableCell>Reference</TableCell>
						<TableCell>Timestamp</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props?.transactions?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.coinTransactionId}
							</TableCell>
							<TableCell component="th" scope="row" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
								<a href={`/dashboard/profile?user_id=${row.userId}`} style={{ marginRight: 8 }}>
									{row.userId}
								</a>
							</TableCell>
							{/*<TableCell component="th" scope="row">
								<UserLevelChip level={row.userLevelStats?.topPct} />
							</TableCell>*/}
							<TableCell component="th" scope="row">
								<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
									<CoinIcon />
									{fCoins(row.amount)}
								</div>
							</TableCell>
							<TableCell component="th" scope="row">
								{getTypeName(row.transactionType, row.reference)}
							</TableCell>
							{/*<TableCell component="th" scope="row">
								<a href={`/dashboard/coin-transaction?transaction_id=${row.pairTransactionId}`}>{row.pairTransactionId}</a>
							</TableCell>*/}
							<TableCell component="th" scope="row">
								{row.reference}
							</TableCell>
							<TableCell component="th" scope="row">
								{fDateTime(row?.createdAt)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
